// extracted by mini-css-extract-plugin
export var chevron = "_av-2";
export var dropdownItems = "_av-0";
export var item = "_av-1";